export default __webpack_public_path__ + "static/media/overleftarrow~hHZihJus.7518b6d4.svg";